export type UnitOfLength = 'mm' | 'cm' | 'm' | 'inch'

export const allUnitsOfLength: UnitOfLength[] = ['mm', 'cm', 'm', 'inch']
